import { ViewModel } from '../view-model';
export class EventStageAction implements ViewModel {
  friendlyTypeNameSingular: string = 'Event Stage Action';
  apiRoute: string;

  actionId: string;
  actionResponse: string;
  actionTypeId: number;
  eventId: string;
  id: string;
  isSkipped: boolean;
  processStageId: string;

  json() {
    return this;
  }

  loadFromJson(data: this) {
    this.actionId = data.actionId;
    this.actionResponse = data.actionResponse;
    this.actionTypeId = data.actionTypeId;
    this.eventId = data.eventId;
    this.id = data.id;
    this.isSkipped = data.isSkipped;
    this.processStageId = data.processStageId;
  }
}
